import React from 'react';

const ContactInfo = () => (
  <div className="p-4 mb-4">
    <h2 className="text-center mb-3">ข้อมูลติดต่อ</h2>
    <div className="name mb-3">
      <span className="nickname">ก้อง</span> นราธิป หริจิระติวงศ์
    </div>
    <div className="contact-item mb-2 pl-4">
      <i className="contact-icon fa fa-map-marker-alt"></i>
      111/235 The KEY BTS วุฒากาศ<br />
      ถนนริมคลองด่าน แขวงบางค้อ เขตจอมทอง<br />
      กรุงเทพฯ 10150
    </div>
    <div className="contact-item mb-2 pl-4">
      <i className="contact-icon fas fa-mobile-alt"></i>
      084-079-4234
    </div>
    <div className="contact-item mb-2 pl-4">
      <i className="contact-icon far fa-envelope"></i>
      contact@gongideas.com
    </div>
    <div className="contact-item mb-2 pl-4">
      <i className="contact-icon fab fa-facebook-f"></i>
      <a href="https://fb.me/naratip.harijiratiwong" target="_blank" rel="noopener noreferrer">https://fb.me/naratip.harijiratiwong</a>
    </div>
    <div className="contact-item mb-2 pl-4">
      <i className="contact-icon fab fa-line"></i>
      90n9
    </div>
  </div>
);

export default ContactInfo;


// WEBPACK FOOTER //
// ./src/components/contact/ContactInfo.js